module.exports = __webpack_public_path__ + "img/unsplash_g1Kr4Ozfoac.97f1a832.png";